/**
 * MN Footer newsletter — play decorative image when section is in view.
 */
function mnFooterNewsletterInit(root) {
  if (!(root instanceof HTMLElement) || root.dataset.mnFooterNewsletterReady === 'true') return;
  root.dataset.mnFooterNewsletterReady = 'true';

  const decor = root.querySelector('[data-mn-footer-newsletter-decor]');
  if (!(decor instanceof HTMLElement) || !decor.classList.contains('mn-footer-newsletter__decor--ready')) {
    return;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    decor.classList.add('is-in-view');
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      const visible = entries.some((entry) => entry.isIntersecting);
      if (!visible) return;
      decor.classList.add('is-in-view');
      observer.disconnect();
    },
    { threshold: 0.2, rootMargin: '0px 0px -5% 0px' }
  );

  observer.observe(root);
}

function mnFooterNewsletterScan(scope) {
  const root = scope && scope.querySelectorAll ? scope : document;
  root.querySelectorAll('[data-mn-footer-newsletter]').forEach(mnFooterNewsletterInit);
}

document.addEventListener('DOMContentLoaded', () => mnFooterNewsletterScan(document));
document.addEventListener('shopify:section:load', (event) => mnFooterNewsletterScan(event.target));
document.addEventListener('shopify:section:preload', (event) => mnFooterNewsletterScan(event.target));
